import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostBinding,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild,
    computed,
    signal,
} from '@angular/core';

import { EventModel, Message } from '@frontend/sports/betting-offer/feature/model';
import { ScoreboardBackgroundConfig } from '@frontend/sports/common/client-config-data-access';
import { NgScrollbar } from 'ngx-scrollbar';

import { ScoreboardMediaTrackingService } from './scoreboard-media-tracking.service';

@Component({
    selector: 'ms-scoreboard-message-list',
    templateUrl: 'scoreboard-message-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ScoreboardMessageListComponent implements OnChanges {
    @HostBinding('class') className = 'scoreboard-message-list';
    @Input() event: EventModel;
    @Input() hasLiveAlert: boolean;
    @Input() set messages(messages: Message[] | undefined) {
        this._messages.set(messages);
    }

    @Output() toggle = new EventEmitter<boolean>();
    @ViewChild(NgScrollbar, { static: true }) messageList: NgScrollbar;

    _messages = signal<Message[] | undefined>(undefined);
    backgroundColor = signal('');
    expanded = signal(false);

    constructor(
        private scoreboardMediaTrackingService: ScoreboardMediaTrackingService,
        private scoreboardBackgrounds: ScoreboardBackgroundConfig,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['event']) {
            if (this.expanded) {
                this.expanded.set(false);
                this.toggle.emit(false);
            }
            const backgroundColor = this.getScoreboardBackgroundColor();
            if (this.backgroundColor() !== backgroundColor) {
                this.backgroundColor.set(backgroundColor);
            }
        }
        if (changes['messages'] && this.messageList) {
            this.messageList.update();
        }
    }

    messageTrack(index: number, message: Message): string {
        return message.time;
    }

    toggleExpand(): void {
        if (!this.hasMessagesForExpand()) {
            return;
        }
        this.expanded.update((value) => !value);
        this.toggle.emit(this.expanded());

        this.scoreboardMediaTrackingService.trackScoreboardMessageList(this.expanded(), this.event);
    }

    private getScoreboardBackgroundColor(): string {
        return this.scoreboardBackgrounds.backgrounds.find((x) => x.sportId === this.event.sport.id && x.src)?.outerColor ?? '';
    }

    lastMessage = computed(() => this._messages()?.[0]);
    remainingMessages = computed(() => this._messages()?.slice(1));
    hasMessagesForExpand = computed(() => !!this.remainingMessages());
}
